/* eslint-disable no-undef */
import React, {useEffect} from 'react';
import CreateTemplate from './CreateTemplates'
import TemplatesCreated from './TemplatesCreated'

export default function Templates() {
    useEffect(() => {
        global.MENU_MODULE_SELECT = 'plantilla'
    }, []);

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="custom-tabs-three-home-tab" data-toggle="pill" href="#custom-tabs-three-home" role="tab" aria-controls="custom-tabs-three-home" aria-selected="true">
                                                    <i className="fas fa-edit"></i> Crear Plantilla
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="custom-tabs-three-profile-tab" data-toggle="pill" href="#custom-tabs-three-profile" role="tab" aria-controls="custom-tabs-three-profile" aria-selected="false">
                                                    <i className="fas fa-list"></i> Ver Plantillas creadas
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="custom-tabs-three-tabContent">
                                            <div className="tab-pane fade show active" id="custom-tabs-three-home" role="tabpanel" aria-labelledby="custom-tabs-three-home-tab">
                                                <CreateTemplate />
                                            </div>
                                            <div className="tab-pane fade" id="custom-tabs-three-profile" role="tabpanel" aria-labelledby="custom-tabs-three-profile-tab">
                                                <TemplatesCreated />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div >
        </>
    )
}
